import { useContext, useMemo, type FC } from "react";

import AddPageSubMenu from "src/components/layouts/AddPageSubMenu";
import TrialIdentityContext from "src/contexts/data/TrialIdentityContext";
import { createTrialConfigurationSubMenu } from "src/routing/navigation";

/**
 * Registers the trial configuration submenu through the shared layout adapter.
 *
 * Postconditions: A rendered registration requests layout updates after render and removes its
 * submenu code on cleanup. Navigation factories retain responsibility for link metadata.
 * A missing or zero trial ID renders nothing; factory results are memoized by identity reference.
 */
const TrialConfigurationSubMenu: FC = () => {
    const { data: trialIdentity } = useContext(TrialIdentityContext);

    const subMenu = useMemo(
        () => (trialIdentity?.id ? createTrialConfigurationSubMenu(trialIdentity.id) : undefined),
        [trialIdentity]
    );

    return subMenu ? <AddPageSubMenu subMenu={subMenu} /> : null;
};

export default TrialConfigurationSubMenu;
